import { Carousel } from '../components/carousel';
import { ThreeItemGrid } from '../components/grid/three-items';
import Footer from '../components/layout/footer';
import { HeroSearchSection } from '../components/kiosk/hero-search-section';
import { KiosksSection } from '../components/kiosk/kiosks-section';
import { useMarketplace } from '../context/MarketplaceContext';

export default function HomePage() {
  const { marketplaceType } = useMarketplace();

  // Page spéciale pour Kiosk
  if (marketplaceType === 'kiosk') {
    return (
      <>
        <HeroSearchSection />
        <KiosksSection />
        <Footer />
      </>
    );
  }

  // Page par défaut pour les autres marketplaces
  return (
    <>
      <ThreeItemGrid />
      <Carousel />
      <Footer />
    </>
  );
}

